import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";


interface DialogDataTableItem
{
	id: String,
	label: String
}

interface DialogDataTable
{
	dataTitle: String;
	viewList: DialogDataTableItem[];
	hideList: DialogDataTableItem[];
}

@Component({
  selector: 'app-data-table-settings',
  templateUrl: './data-table-settings.component.html',
  styleUrls: ['./data-table-settings.component.scss']
})
export class DataTableSettingsComponent{

	constructor(
		public dialogRef: MatDialogRef<DataTableSettingsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogDataTable,
	)
	{
	}

	onNoClick(): void
	{
		this.dialogRef.close();
	}

	onResetClick(): void
	{
		// ui filters reset
		while ( this.data && this.data.hideList.length > 0 )
		{
			this.transferArrayItem(0, "view");
		}
	}


	drop(event: CdkDragDrop<DialogDataTableItem[]>)
	{
		if (event.previousContainer === event.container)
		{
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else
		{
			transferArrayItem(
				event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex,
			);
		}
	}

	transferArrayItem(itemIndex: number, to: 'view' | 'hide')
	{
		if (to === 'view')
		{
			transferArrayItem(
				this.data.hideList,
				this.data.viewList,
				itemIndex,
				this.data.viewList.length,
			);
		} else
		{
			transferArrayItem(
				this.data.viewList,
				this.data.hideList,
				itemIndex,
				this.data.hideList.length,
			);
		}

	}

}
